import { axiosPrivate } from "@/api/axios";
import API_ROUTES from "@/api/apiRoutes";
import { Ticket, ReplyTicketPayload } from "../types";

export async function fetchAllTickets(): Promise<Ticket[]> {
  const res = await axiosPrivate.get(API_ROUTES.SUPPORT.TICKETS);
  const payload = res.data?.data ?? res.data?.results ?? res.data;
  return Array.isArray(payload) ? (payload as Ticket[]) : [];
}

export async function replyToTicket(ticketId: number, data: ReplyTicketPayload): Promise<Ticket> {
  const res = await axiosPrivate.patch(API_ROUTES.SUPPORT.REPLY(ticketId), { admin_reply: data.admin_reply });
  return (res.data?.data ?? res.data) as Ticket;
}
